import React, { Component } from "react";
import { connect } from "react-redux";

import moment from "moment";
import { NavLink } from "react-router-dom";

import * as select from "../reducers";
import * as actionsModals from "../actions/modals";

import "../styles/components/_footer.scss";
import "../styles/components/modals/_terms-and-conditions.scss";

class Footer extends Component {
  render() {
    const { setModalTermsOpen } = this.props;

    return (
      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__left">
            <span>&copy; AFES {moment().year()}</span>{" "}
            <a
              href="http://www.customd.com/"
              target="_blank"
              className="text_link"
              rel="noreferrer"
            >
              Web design and development by Custom D
            </a>
          </div>
          <div className="footer__right">
            <a
              className="text_link"
              href="https://www.afes.org.au"
              target="_blank"
              rel="noreferrer"
            >
              afes.org.au
            </a>
            <NavLink
              className={({ isActive }) =>
                `text_link ${isActive ? "active" : ""}`
              }
              data-remodal-target="terms-and-conditions"
              to="/settings"
              onClick={(e) => {
                e.preventDefault();
                setModalTermsOpen();
              }}
            >
              Terms &amp; Conditions
            </NavLink>
            <a
              className="text_link"
              href="https://www.afes.org.au/privacy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy
            </a>
            <a className="text_link" href="/contact" target="_self">
              Feedback
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    settings: select.getSettings(state),
  };
};

export default connect(mapStateToProps, actionsModals)(Footer);
